interface CosmeticJsonLdProps {
	cosmetic: any
}

export function CosmeticJsonLd({ cosmetic }: CosmeticJsonLdProps) {
	const jsonLd = {
		'@context': 'https://schema.org/',
		'@type': 'Product',
		name: cosmetic.name,
		description: cosmetic.description,
		image: cosmetic.images.icon || cosmetic.images.featured,
		brand: {
			'@type': 'Brand',
			name: 'Fortnite',
		},
		offers: {
			'@type': 'Offer',
			availability: 'https://schema.org/InStock',
			price: '0',
			priceCurrency: 'USD',
		},
		additionalProperty: [
			{
				'@type': 'PropertyValue',
				name: 'Rarity',
				value: cosmetic.rarity,
			},
			{
				'@type': 'PropertyValue',
				name: 'Type',
				value: cosmetic.type,
			},
			{
				'@type': 'PropertyValue',
				name: 'IntroducedIn',
				value: cosmetic.introducedIn,
			},
		],
	}

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
		/>
	)
}
